<template>
  <div class="ui container view">
    <table class="section ui celled table">
      <thead>
        <tr>
          <th class="title" colspan="3">
            Fixed Cost Items
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="item" v-for="item in quote.fixed_cost_items.items">
          <td class="description">
            <div class="ui transparent input">
              <input v-model="item.title" type="text">
            </div>
          </td>
          <td class="amount">
            <div class="ui transparent input">
              $<input v-model.number="item.amount" @change="calcTotalAmount" type="text">
            </div>
          </td>
          <td class="controls">
            <a @click.prevent="confirmItemRemoval(item)" href="#" title="Delete Item">
              <i class="red remove link icon"></i>
            </a>
          </td>
        </tr>
        <tr>
          <td class="description"><strong>Total</strong></td>
          <td class="amount"><strong>{{ quote.fixed_cost_items.amount | currency }}</strong></td>
          <td class="controls">
            <a @click.prevent="addItem" href="#" title="Add Item">
              <i class="green plus link icon"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <modal-confirm :payload="confirmPayload" v-on:confirm="remove" />
  </div>
</template>

<script>
import _ from 'lodash'
import ModalConfirm from './ModalConfirm.vue'

export default {
  data () {
    return {
      quote: {},
      confirmPayload: {}
    }
  },

  components: {
    ModalConfirm
  },

  computed: {
    quoteIsLoaded () {
      return this.$store.getters.quoteIsLoaded
    }
  },

  methods: {
    updateQuote () {
      this.$store.commit('UPDATE_QUOTE', { payload: JSON.stringify(this.quote) })
    },

    addItem () {
      var newItem = { title: 'New Item', amount: 0 }
      this.quote.fixed_cost_items.items.push(newItem)
      this.updateQuote()
    },

    calcTotalAmount () {
      this.quote.fixed_cost_items.amount = _.sumBy(this.quote.fixed_cost_items.items, 'amount')
      this.updateQuote()
    },

    confirmItemRemoval (item) {
      this.confirmPayload = {
        message: `Are you sure you want to remove the <strong>${item.title}</strong> item?`,
        target: 'item',
        item: item
      }
      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show')
    },

    remove (confirmed) {
      if (confirmed) {
        var payload = this.confirmPayload
        switch (payload.target) {
          case 'item': {
            let item = payload.item
            let index = this.quote.fixed_cost_items.items.indexOf(item)
            this.quote.fixed_cost_items.items.splice(index, 1)
            this.calcTotalAmount()
            break
          }
        }
      } else {
        this.confirmPayload = {}
      }
    }
  },

  created () {
    if (this.$store.getters.quoteIsLoaded) {
      this.quote = JSON.parse(this.$store.getters.loadQuote)
    } else {
      console.log('Quote not yet loaded. Redirecting...')
      this.$router.replace({ name: 'new' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ui.transparent.input {
    input:hover,
    input:focus {
      background-color: #eee !important;
    }
  }

  .ui.table tr {
    td.controls,
    th.controls {
      text-align: center;
      width: 5%;
    }

    th.title .ui.transparent.input {
      font-weight: bold;
      width: 50%;
    }

    td {
      &.description {
        width: 90%;

        .ui.transparent.input {
          width: 100%;
        }
      }

      &.type {
        text-align: center;
        width: 10%;
      }

      &.hours {
        text-align: center;
        width: 5%;

        input {
          text-align: center;
          width: 2em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FixedCostItems.vue?05c5c8f9